"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

/**
 * Aria class.
 */
var Aria = /*#__PURE__*/function () {
  function Aria() {
    (0, _classCallCheck2.default)(this, Aria);
    // eslint-disable-next-line max-len
    this.collectInteractiveChildren = this.collectInteractiveChildren.bind(this);
    this.setFocusToFirstItem = this.setFocusToFirstItem.bind(this);
    this.selectors = ['a[href]', 'area[href]', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'iframe', 'object', 'embed', '[contenteditable]', '[tabindex]:not([tabindex^="-"])'].join(',');
    this.tabKey = 9;
    this.escapeKey = 27;
  }
  /**
   * Collect all interactive child elements.
   */


  (0, _createClass2.default)(Aria, [{
    key: "collectInteractiveChildren",
    value: function collectInteractiveChildren() {
      var _this = this;

      if (undefined === this.targetElement) {
        // eslint-disable-next-line no-console
        console.error('No `targetElement` specified for collectInteractiveChildren');
        return;
      }

      var interactiveElements = this.targetElement.querySelectorAll(this.selectors);
      this.interactiveChildElements = Array.prototype.filter.call(interactiveElements, function (child) {
        return _this.constructor.isVisible(child);
      });
    }
    /**
     * Focus the dialog's first interactive child.
     */

  }, {
    key: "setFocusToFirstItem",
    value: function setFocusToFirstItem() {
      if (this.interactiveChildElements.length) {
        this.interactiveChildElements[0].focus();
      }
    }
  }], [{
    key: "eventPolyfill",
    value:
    /**
     * Polyfill CustomEvent.
     *
     * @static
     * @returns {Boolean}
     */
    function eventPolyfill() {
      if ('function' === typeof window.CustomEvent) {
        return false;
      }

      function CustomEvent(event) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
          bubbles: false,
          cancelable: false,
          detail: undefined
        };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
      }

      CustomEvent.prototype = window.Event.prototype;
      window.CustomEvent = CustomEvent;
      return true;
    }
    /**
     * Dispatch a CustomEvent.
     *
     * @static
     * @param {String} type The type of the event.
     * @param {Object} detail Data to be passed with the event.
     * @param {HTMLElement} detail The element upon which the event should be dispatched.
     */

  }, {
    key: "dispatchAriaEvent",
    value: function dispatchAriaEvent(type) {
      var detail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var element = arguments[2];
      var event = new CustomEvent(type, {
        bubbles: true,
        cancelable: true,
        detail: detail
      });
      element.dispatchEvent(event);
    }
    /**
     * Check if an element is visible
     *
     * @static
     * @param {HTMLElement} element The element whose visibility is being checked
     * @returns {Boolean}
     */

  }, {
    key: "isVisible",
    value: function isVisible(element) {
      return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
    }
    /**
     * Create an `id` attribute for the target element, based on a derpHash of the element's className.
     *
     * @returns {String}
     */

  }, {
    key: "generateTargetId",
    value: function generateTargetId(element) {
      var targetClasses = element.className; // derpHash: Ensure a passably unique ID (but lets not go overboard)

      var derpHash = (Math.random() / targetClasses.length).toString(16).split('.')[1];
      return "id_".concat(derpHash, "_").concat(targetClasses.split(' ').join('_'));
    }
  }]);
  return Aria;
}();

exports.default = Aria;